/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiGetUsersFilterFromJSON, ApiGetUsersFilterToJSON, } from './ApiGetUsersFilter';
export function InlineObject3FromJSON(json) {
    return InlineObject3FromJSONTyped(json, false);
}
export function InlineObject3FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'filters': !exists(json, 'filters') ? undefined : (json['filters'].map(ApiGetUsersFilterFromJSON)),
        'leadId': !exists(json, 'leadId') ? undefined : json['leadId'],
        'leadIds': !exists(json, 'leadIds') ? undefined : json['leadIds'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'pageToken': !exists(json, 'pageToken') ? undefined : json['pageToken'],
        'search': !exists(json, 'search') ? undefined : json['search'],
    };
}
export function InlineObject3ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'filters': value.filters === undefined ? undefined : (value.filters.map(ApiGetUsersFilterToJSON)),
        'leadId': value.leadId,
        'leadIds': value.leadIds,
        'pageSize': value.pageSize,
        'pageToken': value.pageToken,
        'search': value.search,
    };
}
